export enum EventType {
  Inside = 1,
  Outside = 2,
  Other = 3,
}

export const REGIONS = ['ATL', 'Chesapeake', 'DMV', 'Houston', 'RVA'].map(
  (value) => ({
    id: value,
    label: value,
    value,
  })
);

export const EVENT_TYPES = [
  {
    label: 'Inside',
    value: EventType.Inside,
  },
  {
    label: 'Outside',
    value: EventType.Outside,
  },
  {
    label: 'Other',
    value: EventType.Other,
  },
];
